const isJSDebugMode =
  typeof window !== 'undefined' &&
  window.location.search.indexOf('icook_js_debug=true') !== -1;

export default isJSDebugMode;
